export default {
  text: {
    display: 'inline-block',
    minWidth: '150px',
    marginRight: '20px',
    textAlign: 'right',
  },
  tirtle: {
    width: '100%',
    borderBottom: '1px solid #999',
    padding: '10px 0'
  },
  colorRed: {
    color: 'rgb(255, 0, 0)'
  }
};



// WEBPACK FOOTER //
// ./src/Parts/TitlePart/style.js